module.exports = __webpack_public_path__ + "img/samoyed.63a8d009.svg";